import { render, staticRenderFns } from "./RestablecerPassword.vue?vue&type=template&id=2cec8c44&scoped=true"
import script from "./RestablecerPassword.vue?vue&type=script&lang=js"
export * from "./RestablecerPassword.vue?vue&type=script&lang=js"
import style0 from "./RestablecerPassword.vue?vue&type=style&index=0&id=2cec8c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cec8c44",
  null
  
)

export default component.exports